/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * @private
 * @typedef {Record<string, *>} SoundManager TODO #555
 */

/**
 * @typedef {Pick<import('../../content/info/content-info').ContentInfo, 'volume'>} IContentInfo
 */

/**
 * Nahrazovač hlasitosti zařízení
 *
 * Stará se o aktualizaci master hlasitosti zařízení dle obsahu datového skladu.
 */
class ReplacerSound {
  /**
   * Vytvoří instanci.
   * @param {SoundManager} soundManager
   */
  constructor(soundManager) {
    this.soundManager = soundManager;
  }

  /**
   * Změní hlasitost zařízení dle datového skladu.
   * @param {IContentInfo} contentInfo
   * @returns {Promise<void>} Vyřeší se po dokončení změny.
   */
  replace(contentInfo) {
    return new Promise((resolve) => {
      // Zjištění hodnoty hlasitosti.
      const { volume } = contentInfo;
      // Změna hlasitosti.
      return resolve(this.soundManager.setVolume(volume));
    });
  }
}

export default ReplacerSound;
